@if (!loading()) {
  @if (freights().length <= 0 && hasViewMarketCapability()) {
    <lib-freight-available-card-go-to-list-cta></lib-freight-available-card-go-to-list-cta>
  }
}

<h2>
  {{ 'general.today' | translate }}
  <span class="text-medium fs-xs ff-base">{{ today | dfnsFormat: 'ccc P' }}</span>
</h2>

@if (loading()) {
  <lib-skeleton-card-inprogress></lib-skeleton-card-inprogress>
  <lib-spinner-loading></lib-spinner-loading>
} @else {
  @if (freights().length <= 0) {
    <lib-empty-result text="freight.general.without_freights"></lib-empty-result>
  } @else {
    @for (freight of freights(); track freight.id) {
      <lib-freight-carrier-inprogress-card
        [hideColumns]="true"
        [freight]="freight"
      ></lib-freight-carrier-inprogress-card>
    }
    @if (hasMore()) {
      <ion-button
        fill="outline"
        size="small"
        expand="block"
        (click)="seeMore.emit()"
      >
        {{ 'freight.general.see_more' | translate }}
      </ion-button>
    }
  }
}
